import { gql, useQuery } from '@apollo/client'

import {
  NotificationBoxFragmentDoc,
  NotificationDetailQuery,
  NotificationDetailQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ notificationId: string }>()
  const { data, loading } = useQuery<
    NotificationDetailQuery,
    NotificationDetailQueryVariables
  >(QUERY, { variables: { notificationId: router.query.notificationId } })

  // call mutation update unread count -> implemented in the future
  // update badge number by Badge.setCount(-1) function

  return {
    state: {
      loading,
      notification: data?.organization?.notification ?? null,
    },
    actions: {},
  }
})

const QUERY = gql`
  query NotificationDetail($notificationId: ID!) {
    organization {
      id
      notification(id: $notificationId) {
        ...NotificationBox
      }
    }
  }
  ${NotificationBoxFragmentDoc}
`
